import * as api from './api'
import { SETTINGS } from '@/constants/localStorage'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { checkTtlDate } from '@/helper'

import { THREE_HOUR } from '@/constants/time'

export default {
  async loadMainData ({ commit }) {
    const settingsLocal = getLocalData(SETTINGS)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (settingsLocal?.updateDate || 0),
      ttlTime: THREE_HOUR,
    })

    if (settingsLocal && !isNeedUpdate) {
      commit('setData', settingsLocal.data)

      return { data: settingsLocal.data }
    }

    const { data } = await api.loadMainData() || {}

    if (data?.code === 200) {
      setLocalData(SETTINGS, {
        updateDate: Date.now(),
        data: data.data
      })

      commit('setData', data.data)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async loadModalData (_, { name, type }) {
    const { data } = await api.loadModalData(name, type) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  }
}